import React, { useState, useEffect } from 'react'
import { Modal } from 'rsuite'
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from 'draft-js';
import { useStore } from 'react-redux'

const QaNotesModal = ({ show, onClose, onDone, title = '', size = 'sm', isShareCallModal = false, page = '', qaReject = false, setMarkAsReject }) => {
  const store = useStore().getState()
  const {
    user: {
      domainUsers
    }
  } = store
  const [hideEditorClass, setHideEditorClass] = useState('hide')
  const [markRejected, setMarkRejected] = useState(false)
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const userSuggestion = []

  domainUsers && domainUsers.map((user) => {
    var text = user?.user?.firstname + (user?.user?.lastname ? ' ' + user?.user?.lastname : '')
    var value = user?.user?.email
    if (page === 'report') {
      userSuggestion.push({ text: text, value: text, url: 'https://' + value + '/' + user?.user?.id })
    } else {
      userSuggestion.push({ text: text, value: text, url: 'https://' + value })
    }
  })

  const handleClickDone = (isReenable = false) => {
    if (page === "masterSupplierDetail" && !qaReject) {
      onDone(editorState)
    } else if (page === "masterSupplierDetail" && qaReject) {
      onDone(editorState, '', isReenable)
    } else {
      onDone(editorState, null, '', '', null, '', isReenable)
    }
    !isShareCallModal && handleOnClose()
  }

  const updateTextDescription = async (state) => {
    setHideEditorClass('')
    await setEditorState(state);
  };
  const handleCancelButton = () => {
    handleOnClose()
    setEditorState(EditorState.createEmpty())
  }

  useEffect(() => {
    setEditorState(EditorState.createEmpty())
  }, [show])

  const handleOnClose = () => {
    setHideEditorClass('hide')
    onClose()
  }

  const markAsRejectHandler = (e) => {
    console.log("e", e)
  }

  return (
    <Modal
      backdrop={true}
      className="qa-notes-modal"
      show={show}
      size={size}
      onClick={handleOnClose}
      onHide={handleOnClose}
    >
      <Modal.Header>
        <Modal.Title className='text-black fw-bold fs-3 mb-0'>
          {title ? title : 'QA Notes'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='master-supplier-history-panel'>
        <div className='supplier-history-editor-parent'>
          <h3 className='fw-bold text-black'> Add Note </h3>
          <Editor
            editorState={editorState}
            toolbarClassName={`supplier-history-editor-toolbar ${hideEditorClass}`}
            wrapperClassName="supplier-history-editor-wrapper flex"
            editorClassName="supplier-history-editor h5"
            onEditorStateChange={updateTextDescription}
            mention={{
              separator: ' ',
              trigger: '@',
              suggestions: userSuggestion,
            }}
          />
          {(!qaReject && page !== "masterSupplierDetail") && <div className={`notes-editor-custom-buttons flex me-0 ${hideEditorClass}`}>
            <button className='notes-cancel-button' onClick={handleCancelButton}>Cancel</button>
            <button className='notes-save-button' onClick={handleClickDone}>Save</button>
          </div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {(!qaReject && (page === "masterSupplierDetail")) && (
          <div className={`d-flex column-gap-4 ${page === "auto-matched-children" ? 'justify-content-end' : 'justify-content-between pe-4'}`} >
            {page === "masterSupplierDetail" && <div className={`col-4 d-flex align-items-center column-gap-3`}>
              <input type='checkbox' style={{ height: 18, width: 18 }} onChange={(e) => { setMarkAsReject(e.target.checked) }} />
              <label className='fs-4 fw-semibold' >Mark As Rejected</label>
            </div>}
            <div className={`col-8 d-flex column-gap-3 ${page === "auto-matched-children" ? 'justify-content-end' : ''}`}>
              <button className='btn btn-secondary btn-lg w-25' onClick={handleCancelButton}>Cancel</button>
              <button className='btn btn-green btn-lg  w-25' onClick={handleClickDone}>Save</button>
            </div>
          </div>)}

        {qaReject && <div className='d-flex gap-3 justify-content-end'>
          <button className='btn btn-secondary px-4 py-2 fs-5' onClick={handleCancelButton}>Cancel</button>
          <button className='btn btn-green px-4 py-2 fs-5' onClick={() => { handleClickDone(true) }}>Confirm and Reenable</button>
          <button className='btn btn-primary px-4 py-2 fs-5' onClick={() => { handleClickDone(false) }}>Confirm </button>
        </div>}
      </Modal.Footer>
    </Modal>
  )
}
export default QaNotesModal